import compact from 'lodash/compact';
const defaultKey = ['user-manager'];
const keys = {
    default: defaultKey,
    userManager: (placementId) => {
        return compact([...defaultKey, placementId]);
    }
};
export default keys;
